<div class="container">
	<h1 class="title">{{ 'leave_popover.title' | translate }}</h1>
	<p class="info">{{ 'leave_popover.info' | translate }}</p>
	<div (click)="dismiss(leaveEnum.NAVIGATE_BACK)" class="button button_main">{{ 'leave_popover.yes' | translate }}</div>
	<div (click)="dismiss(leaveEnum.STAY)" class="button button_close">{{ 'leave_popover.no' | translate }}</div>
</div>
